import { inject, Injectable } from '@angular/core';
import { ApiService } from '@core/api';
import { Observable } from 'rxjs';
import { TicketDto } from '@core/hera-models';
import { HttpHeaders, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class TicketDataService {
  private apiService = inject(ApiService);

  getTicketByOrderId(orderId: string): Observable<TicketDto> {
    return this.apiService.getV2(
      `orders/${orderId}/ticket`,
      new HttpParams(),
      new HttpHeaders()
    );
  }
}
